var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJogos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4054 10.3746C19.4054 15.4191 15.3156 19.509 10.2711 19.509C5.22659 19.509 1.13672 15.42 1.13672 10.3746C1.13672 5.32921 5.22659 1.24023 10.2711 1.24023C11.146 1.24023 11.9932 1.36292 12.7947 1.59307C16.6123 2.6883 19.4054 6.20503 19.4054 10.3746Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62891 7.41911C4.62891 7.41911 5.07667 5.1803 6.33041 4.01612C7.58414 2.85193 10.7185 2.76238 11.2558 2.85193C11.7931 2.94149 13.8528 5.26985 13.8528 5.26985L12.0618 10.1057L7.94235 10.9117L4.62891 7.41911Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63009 7.41992C4.63009 7.41992 2.48083 8.04679 2.12262 8.67366C1.76441 9.30053 1.58531 13.1513 1.85396 13.5991C2.12262 14.0468 4.27188 16.017 4.27188 16.017C4.27188 16.017 4.33726 17.3513 4.61845 17.5797",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94206 6.61328C1.94206 6.61328 1.85251 7.86702 2.12117 8.67299",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27148 16.0166L7.67448 14.6733L7.94314 10.9121",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0538 10.0059L14.2112 13.4187L11.435 16.4635L7.67383 14.6724",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1457 19.3314L11.4355 16.4648",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2117 13.4203L17.9729 13.0621C17.9729 13.0621 19.3162 9.92774 19.2267 9.03222C19.1371 8.13669 16.8088 5.45011 16.2714 5.27101C15.7341 5.0919 13.8535 5.27101 13.8535 5.27101",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.877 15.4185C17.877 15.4185 18.2414 13.5083 17.9728 13.0605",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2559 2.85134C11.2559 2.85134 12.0806 1.76507 13.1454 1.72656",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.361 5.26926C16.361 5.26926 16.001 3.45582 15.375 2.79492",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42025 3.83781C5.85338 3.62915 5.28562 3.4196 4.71875 3.21094",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJogos);
export default __webpack_public_path__ + "static/media/Jogos.c8a3b5d31e7f906ad4f3978f0f0826dd.svg";
export { ForwardRef as ReactComponent };